import * as Types from '../../../../packages/graphql/generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type MirrorCardQueryVariables = Types.Exact<{
  idCard: Types.Scalars['ID'];
}>;


export type MirrorCardQuery = (
  { __typename: 'Query' }
  & { card?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'id' | 'name'>
    & { board: (
      { __typename: 'Board' }
      & Pick<Types.Board, 'id' | 'name'>
    ), list: (
      { __typename: 'List' }
      & Pick<Types.List, 'id' | 'name'>
    ) }
  )> }
);


export const MirrorCardDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MirrorCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idCard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idCard"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"list"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]};

/**
 * __useMirrorCardQuery__
 *
 * To run a query within a React component, call `useMirrorCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMirrorCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMirrorCardQuery({
 *   variables: {
 *      idCard: // value for 'idCard'
 *   },
 * });
 */
export function useMirrorCardQuery(baseOptions: Apollo.QueryHookOptions<MirrorCardQuery, MirrorCardQueryVariables>) {
        return Apollo.useQuery<MirrorCardQuery, MirrorCardQueryVariables>(MirrorCardDocument, baseOptions);
      }
export function useMirrorCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MirrorCardQuery, MirrorCardQueryVariables>) {
          return Apollo.useLazyQuery<MirrorCardQuery, MirrorCardQueryVariables>(MirrorCardDocument, baseOptions);
        }
export type MirrorCardQueryHookResult = ReturnType<typeof useMirrorCardQuery>;
export type MirrorCardLazyQueryHookResult = ReturnType<typeof useMirrorCardLazyQuery>;
export type MirrorCardQueryResult = Apollo.QueryResult<MirrorCardQuery, MirrorCardQueryVariables>;